import { HIDE_TOOLTIP, RESET_STATE } from '../../reducer';

export const LOAD_COMMISSION_PAID_INDEX = 'LOAD_COMMISSION_PAID_INDEX';
export const SET_COMMISSION_PAID_INDEX_DATA = 'SET_COMMISSION_PAID_INDEX_DATA';
export const LOAD_COMMISSION_PAID_INDEX_FAILURE =
  'LOAD_COMMISSION_PAID_INDEX_FAILURE';
export const CHANGE_PAGINATOR_PAGE =
  'CommissionPaidIndex/CHANGE_PAGINATOR_PAGE';
export const DOWNLOAD_CSV = 'CommissionPaidIndex/DOWNLOAD_CSV';
export const SET_CALENDAR_SAGA = 'CommissionPaidIndex/SET_CALENDAR_SAGA';
export const TOGGLE_FILTER = 'CommissionPaidIndex/TOGGLE_FILTER';
export const SET_STATUS_FILTER = 'CommissionPaidIndex/SET_STATUS_FILTER';
export const SET_CALENDAR_START_FILTER =
  'CommissionPaidIndex/SET_CALENDAR_START_FILTER';
export const SET_CALENDAR_END_FILTER =
  'CommissionPaidIndex/SET_CALENDAR_END_FILTER';
export const CLEAR_CALENDAR_FILTER =
  'CommissionPaidIndex/CLEAR_CALENDAR_FILTER';
export const TOGGLE_CALENDAR_FILTER =
  'CommissionPaidIndex/TOGGLE_CALENDAR_FILTER';
export const SET_PAGINATOR_TOTAL = 'CommissionPaidIndex/SET_PAGINATOR_TOTAL';
export const SET_PER_PAGE_FILTER = 'CommissionPaidIndex/SET_PER_PAGE_FILTER';
export const ORDER_BY_AMOUNT = 'CommissionPaidIndex/ORDER_BY_AMOUNT';
export const SHOW_TOOLTIP = 'CommissionPaidIndex/SHOW_TOOLTIP';

export const showTooltip = activeTooltip => ({
  type: SHOW_TOOLTIP,
  activeTooltip
});

export const loadCommissionPaidIndex = params => ({
  type: LOAD_COMMISSION_PAID_INDEX,
  params
});

export const setCommissionPaidIndex = payload => ({
  type: SET_COMMISSION_PAID_INDEX_DATA,
  payload
});

export const loadCommissionPaidIndexFailure = () => ({
  type: LOAD_COMMISSION_PAID_INDEX_FAILURE
});

export const changePage = pageNumber => ({
  type: CHANGE_PAGINATOR_PAGE,
  pageNumber
});
export const downloadCsv = path => ({
  type: DOWNLOAD_CSV,
  path
});

export const setCalendarSaga = () => ({
  type: SET_CALENDAR_SAGA
});

export const toggleFilter = () => ({
  type: TOGGLE_FILTER
});

export const setStatusFilter = statusFilter => ({
  type: SET_STATUS_FILTER,
  statusFilter
});

export const setPerPageFilter = perPageFilter => ({
  type: SET_PER_PAGE_FILTER,
  perPageFilter
});

export const setCalendarStartFilter = calendarStart => ({
  type: SET_CALENDAR_START_FILTER,
  calendarStart
});

export const setCalendarEndFilter = calendarEnd => ({
  type: SET_CALENDAR_END_FILTER,
  calendarEnd
});

export const clearCalendarFilter = () => ({
  type: CLEAR_CALENDAR_FILTER
});

export const toggleCalendarFilter = () => ({
  type: TOGGLE_CALENDAR_FILTER
});

export const setPaginatorTotal = paginatorTotal => ({
  type: SET_PAGINATOR_TOTAL,
  paginatorTotal
});

export const orderByAmount = orderByState => ({
  type: ORDER_BY_AMOUNT,
  orderByState
});

const displayActiveFilter = (state, key) => ({
  ...state,
  calendarFilterState: false,
  [key]: !state[key]
});

const initialState = {
  loading: true,
  failedLoad: false,
  currentPage: 1,
  previouslyVisited: [1],

  toggleFilterState: true,
  // typeFilter: undefined,
  statusFilter: undefined,
  perPageFilter: 10,
  calendarFilterState: false,

  calendarStart: null,
  calendarEnd: null,
  isMobile: false,
  orderByState: 0,
  orderByType: null,
  activeTooltip: ''
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_COMMISSION_PAID_INDEX_DATA:
      return {
        ...state,
        ...action.payload,
        loading: false
      };
    case LOAD_COMMISSION_PAID_INDEX_FAILURE:
      return {
        ...state,
        failedLoad: true
      };
    case CHANGE_PAGINATOR_PAGE:
      return {
        ...state,
        currentPage: action.pageNumber,
        previouslyVisited: state.previouslyVisited.includes(action.pageNumber)
          ? state.previouslyVisited
          : [...state.previouslyVisited, action.pageNumber]
      };
    case SET_PAGINATOR_TOTAL:
      return {
        ...state,
        paginatorTotal: action.paginatorTotal
      };

    case TOGGLE_FILTER:
      return {
        ...state,
        expandedRow: null,
        previouslyVisited: [1],
        toggleFilterState: !state.toggleFilterState
      };
    case SET_PER_PAGE_FILTER:
      return {
        ...state,
        perPageFilter: action.perPageFilter,
        expandedRow: null,
        previouslyVisited: [1],
        currentPage: 1
      };

    case SET_STATUS_FILTER:
      return {
        ...state,
        expandedRow: null,
        previouslyVisited: [1],
        statusFilter: action.statusFilter
      };
    case SET_CALENDAR_START_FILTER:
      return {
        ...state,
        expandedRow: null,
        previouslyVisited: [1],
        calendarStart: action.calendarStart
      };
    case SET_CALENDAR_END_FILTER:
      return {
        ...state,
        expandedRow: null,
        previouslyVisited: [1],
        calendarEnd: action.calendarEnd
      };
    case CLEAR_CALENDAR_FILTER:
      return {
        ...state,
        expandedRow: null,
        previouslyVisited: [1],
        calendarStart: null,
        calendarEnd: null,
        calendarFilterState: false
      };
    case ORDER_BY_AMOUNT:
      return {
        ...state,
        orderByState: action.orderByState,
        orderByType: 'amount'
      };
    case SHOW_TOOLTIP:
      return {
        ...state,
        activeTooltip: action.activeTooltip
      };
    case HIDE_TOOLTIP:
      return {
        ...state,
        activeTooltip: ''
      };
    case TOGGLE_CALENDAR_FILTER:
      return displayActiveFilter(state, 'calendarFilterState');

    case RESET_STATE:
      return {
        ...state,
        ...initialState
      };
    default:
      return state;
  }
};
